import { AbpHttpInterceptor, RefreshTokenService, AbpHttpConfigurationService } from 'abp-ng2-module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import * as ApiServiceProxies from './service-proxies';
import { ZeroRefreshTokenService } from '@account/auth/zero-refresh-token.service';
import { ZeroTemplateHttpConfigurationService } from './zero-template-http-configuration.service';
import { LocalizePipe } from '@shared/common/pipes/localize.pipe';
import { TimesheetObsService } from '@app/main/time-sheet/services/timesheet-obs.service';
import { RootService } from 'root.service';

@NgModule({
    providers: [
        LocalizePipe,
        RootService,
        ApiServiceProxies.UserOutlookCalendarEventServiceServiceProxy,
        ApiServiceProxies.AppAndWebsiteServiceProxy,
        ApiServiceProxies.ServiceCalendarServiceProxy,
        ApiServiceProxies.TimesheetServiceProxy,
        ApiServiceProxies.ReportServiceProxy,
        ApiServiceProxies.LocationTrackingServiceProxy,
        ApiServiceProxies.BlobHelperServiceProxy,
        ApiServiceProxies.TimeAndAttendanceServiceProxy,
        ApiServiceProxies.ActivityServiceProxy,
        ApiServiceProxies.ApplicationCategoryServiceProxy,
        ApiServiceProxies.AddAwayTimeServiceProxy,
        ApiServiceProxies.OnBoardingServiceProxy,
        ApiServiceProxies.TenantProductServiceProxy,
        ApiServiceProxies.CompanyProfileServiceProxy,
        ApiServiceProxies.ClientServiceProxy,
        ApiServiceProxies.ProjectServiceProxy,
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.ProjectTaskServiceProxy,
        ApiServiceProxies.CachingServiceProxy,
        ApiServiceProxies.ChatServiceProxy,
        ApiServiceProxies.CommonLookupServiceProxy,
        ApiServiceProxies.EditionServiceProxy,
        ApiServiceProxies.FriendshipServiceProxy,
        ApiServiceProxies.HostSettingsServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.LanguageServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        ApiServiceProxies.OrganizationUnitServiceProxy,
        ApiServiceProxies.PermissionServiceProxy,
        ApiServiceProxies.ProfileServiceProxy,
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.TenantDashboardServiceProxy,
        ApiServiceProxies.TenantSettingsServiceProxy,
        ApiServiceProxies.TimingServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.UserLinkServiceProxy,
        ApiServiceProxies.UserLoginServiceProxy,
        ApiServiceProxies.WebLogServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.TenantRegistrationServiceProxy,
        ApiServiceProxies.HostDashboardServiceProxy,
        ApiServiceProxies.PaymentServiceProxy,
        ApiServiceProxies.DemoUiComponentsServiceProxy,
        ApiServiceProxies.InvoiceServiceProxy,
        ApiServiceProxies.AllDashboardServiceProxy,
        ApiServiceProxies.SubscriptionServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.UiCustomizationSettingsServiceProxy,
        ApiServiceProxies.PayPalPaymentServiceProxy,
        ApiServiceProxies.StripePaymentServiceProxy,
        ApiServiceProxies.DashboardCustomizationServiceProxy,
        ApiServiceProxies.WebhookEventServiceProxy,
        ApiServiceProxies.WebhookSubscriptionServiceProxy,
        ApiServiceProxies.WebhookSendAttemptServiceProxy,
        ApiServiceProxies.UserDelegationServiceProxy,
        ApiServiceProxies.DynamicPropertyServiceProxy,
        ApiServiceProxies.DynamicEntityPropertyDefinitionServiceProxy,
        ApiServiceProxies.DynamicEntityPropertyServiceProxy,
        ApiServiceProxies.DynamicPropertyValueServiceProxy,
        ApiServiceProxies.DynamicEntityPropertyValueServiceProxy,
        ApiServiceProxies.TwitterServiceProxy,
        ApiServiceProxies.OutlookCalendarServiceProxy,
        ApiServiceProxies.IdentityProviderServiceProxy,
        ApiServiceProxies.AgentHelperServiceProxy,
        ApiServiceProxies.CommonCacheServiceProxy,
        ApiServiceProxies.TimesheetReStructuringServiceProxy,
        ApiServiceProxies.CountryStateCityAppserviceServiceProxy,
        { provide: RefreshTokenService, useClass: ZeroRefreshTokenService },
        { provide: AbpHttpConfigurationService, useClass: ZeroTemplateHttpConfigurationService },
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true },
    ],
})
export class ServiceProxyModule { }
